import { navigate } from "@reach/router";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "@reach/router";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import { S3_ENDPOINT } from "../../utils";
import Page from "../../components/global/Page";
import "./ClassTypePage.css";

const parseBenefits = (raw) => {
  if (raw == null || String(raw).trim() === "") return [];
  return String(raw)
    .split("/")
    .map((s) => s.trim())
    .filter(Boolean);
};

const ClassTypePage = ({ class_type_id }) => {
  const [classType, setClassType] = useState(null);
  const { class_types, getClassTypes } = useContext(ClassTypeContext);

  useEffect(() => {
    getClassTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [class_type_id]);

  useEffect(() => {
    if (Array.isArray(class_types)) {
      const current = class_types.find(
        (class_type) => class_type.class_type_id === parseInt(class_type_id, 10)
      );
      if (current) {
        setClassType(current);
      } else {
        navigate("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [class_types, class_type_id]);

  const renderMedia = () => {
    if (!classType) return null;
    if (classType.video_url) {
      return (
        <div className="class-type-page__media-wrap">
          <video className="w-100" autoPlay playsInline muted loop>
            <source
              src={`${S3_ENDPOINT}/${classType.video_url}`}
              type="video/mp4"
            />
          </video>
        </div>
      );
    }
    if (classType.file !== null) {
      return (
        <div className="class-type-page__media-wrap">
          <img
            src={`${S3_ENDPOINT}/${classType.file.name}.${classType.file.type}`}
            className="w-100"
            alt={classType.name}
          />
        </div>
      );
    }
    return null;
  };

  const renderBenefitsList = (benefits) => (
    <ul className="class-type-page__benefits">
      {benefits.map((content, index) => (
        <li key={index}>
          <i className="fa fa-check text-primary" aria-hidden="true" />
          <span> {content}</span>
        </li>
      ))}
    </ul>
  );

  const renderVideos = () => {
    if (!classType || !Array.isArray(classType.videos) || classType.videos.length === 0)
      return null;
    return (
      <p className="class-type-page__videos">
        Encontrarás {classType.videos.length} clases de esta disciplina en TBM
        Online
      </p>
    );
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    const hasVideos =
      classType &&
      Array.isArray(classType.videos) &&
      classType.videos.length > 0;
    if (hasVideos) {
      navigate("/online/");
      return;
    }
    navigate(classType && classType.branch_id === 2 ? "/tijuana/" : "/monterrey/");
  };

  const benefitsList = classType ? parseBenefits(classType.benefits) : [];
  const hasBenefits = benefitsList.length > 0;

  return (
    <Page title="">
      <div className="class-type-page__main">
        {classType ? (
          <div className="class-type-page__layout">
            <div className="class-type-page__intro">
              <button
                to="/online/"
                className="btn px-0 py-0 class-type-page__back"
                aria-label="Volver"
                onClick={handleBack}
              >
                <i className="fa fa-chevron-left" aria-hidden="true" />
                Regresar
              </button>
              <h6 className="class-type-page__kicker text-dark mb-2">
                Disciplina
              </h6>
              <h1 className="class-type-page__name text-dark mb-3">
                {classType.name}
              </h1>
            </div>
            <div className="class-type-page__media-column">
              <div className="class-type-page__media-block">{renderMedia()}</div>
              {hasBenefits ? (
                <div className="class-type-page__benefits-card mt-4">
                  <h2 className="bold h3">
                    Beneficios
                  </h2>
                  {renderBenefitsList(benefitsList)}
                </div>
              ) : null}
            </div>
            <aside className="class-type-page__aside">
              <div className="class-type-page__content-card">
                <div className="class-type-page__col-about">
                  <h2 className="bold h3">
                    Acerca de esta disciplina
                  </h2>
                  <div className="class-type-page__body">
                    <p className="mb-0">{classType.description}</p>
                    {renderVideos()}
                  </div>
                </div>
                <div className="mt-4">
                  <Link
                    to="/checkout/149"
                    className="btn btn-primary"
                  >
                    Suscríbete
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        ) : (
          <div className="class-type-page__loading d-flex align-items-center justify-content-center text-dark">
            Cargando…
          </div>
        )}
      </div>
    </Page>
  );
};

export default ClassTypePage;
